<template>
	<b-modal ref="location-modal" title="Select Location" v-model="showLocation" :modal-class="'full-modal no-header no-footer'">
		<div class="container pt-4 pb-0">
			<h2 class="text-uppercase">Select Location</h2>
		</div>
		<hr class='mb-0' />
		<div class='load-wrapper pt-1'>
			<div class="container pt-1">

				<div class="row py-5">
					<div class="mb-5" :class="'col-sm-'+Math.max(Math.floor(12/Object.keys(locations).length), 4)" v-for="(item, index) in locations" v-bind:key="index">
						<a class='d-block' href="#" @click.prevent="start(index)">
							<div class="card text-center">
								<img :src="`${item.img}`" class="card-img-top" :alt="item.title">
								<div class="card-body">
									<h5 class="card-title">{{item.title}}</h5>
									<!-- <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> -->
								</div>
							</div>
						</a>
					</div>
				</div>

			</div>
		</div>


		<div class="footer-btns">
			<div class="container">
				<button class="app-btn btn btn-dark" @click.prevent="view=null">
					<i class="app-icon back mr-2"></i> Back
				</button>
			</div>
		</div>
	</b-modal>
</template>

<style scoped lang="scss" rel="stylesheet/scss">
	.footer-btns {
		position: absolute;
		bottom: 30px;
		text-align: right;
		width: 100%;
	}
	.load-wrapper {
		max-height: calc(100vh - 200px);
		overflow-y: auto;
	}
</style>

<script>

	import * as workerTimers from 'worker-timers';
	import { keys, get, set, del } from 'idb-keyval';

	export default {
		name: 'Location',
		data() {
			return {
				showLocation: false,
				locations: {}
			}
		},
    	computed: {
			view: {
				get() { return this.$store.state.view },
				set(value) { this.$store.commit('setState', ['view', value])}
			},
			logged: {
				get() { return this.$store.state.logged },
				set(value) { this.$store.commit('setState', ['logged', value])}
			},
			location: {
				get() { return this.$store.state.location },
				set(value) { this.$store.commit('setState', ['location', value])}
			}
		},
		async mounted() {
			await this.$http.get('/data/locations.json').then(response => {
				let locations = response.data;

				for (let i in locations) {
					if (!this.$auth.hasLocation(i)) delete locations[i];
				}
				this.locations = locations;
				if (Object.keys(this.locations).length == 1) this.start(Object.keys(this.locations)[0]);
			})
		},
		methods: {
			start(index) {
				this.location = this.locations[index];
				this.logged = true;
				this.view = 'game';
			}
		},
		watch: {
			view: {
				async handler() {
					this.showLocation =  (this.$store.state.view == 'location');
				},
				immediate: true
			}
		}

	}
</script>
